import { DOCUMENT } from '@angular/common';
import { inject, Service } from '@angular/core';

/**
 * Sets Correct language in <html lang={}> tag
 */
@Service()
export class I18nHtmlLangService {
    private readonly document = inject(DOCUMENT);

    /**
     * Sets correct HTML Doc language
     */
    setLang(lang: string): void {
        const ln = lang.split('-')[0];
        this.document.documentElement.lang = ln;
    }
}
